<nav class="breadcrumbs" aria-label="breadcrumb">
    <ngx-spinner
        type="ball-clip-rotate"
        [fullScreen]="false"
        name="breadcrumbs"></ngx-spinner>
    <ol class="breadcrumb">
        <li
            class="breadcrumb-item"
            *ngFor="
                let item of breadcrumbs || breadcrumbService.breadcrumbs;
                index as idx
            "
            [ngClass]="{ active: item.active }">
            <a
                [routerLink]="item.link"
                [queryParams]="item.queryParams"
                *ngIf="item.link">
                <div style="position: relative">
                    <ngx-spinner
                        type="ball-clip-rotate"
                        [fullScreen]="false"
                        [name]="'breadcrumb-' + idx"></ngx-spinner>
                    {{ item.text }}
                </div>
            </a>
            <div class="d-flex" style="position: relative">
                <ngx-spinner
                    type="ball-clip-rotate"
                    [fullScreen]="false"
                    [name]="'breadcrumb-' + idx"></ngx-spinner>
                {{ (item.active && item.text) || '' }}
            </div>
        </li>
    </ol>
</nav>
